import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  style: {"enable-background":"new 0 0 32 32"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"stroke-width":"2","stroke":"currentcolor","fill":"none","stroke-miterlimit":"10"},
      d: "m3 9.5 13 13 13-13"
    }, null, -1)
  ])))
}
export default { render: render }